<div class="properties-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>info</mat-icon>
      File Properties
    </h2>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <!-- File Overview Section -->
    <div class="properties-section">
      <h3 class="section-title">
        <mat-icon>description</mat-icon>
        File Information
      </h3>

      <mat-list>
        <!-- File Name -->
        <mat-list-item>
          <span class="property-label">File Name</span>
          <span class="property-value">{{ metadata.fileName }}</span>
          <button
            mat-icon-button
            (click)="copyToClipboard(metadata.fileName)"
            matTooltip="Copy to clipboard"
            class="copy-button"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-list-item>

        <!-- File ID -->
        <mat-list-item>
          <span class="property-label">File ID</span>
          <span class="property-value file-id">{{ metadata.fileId }}</span>
          <button
            mat-icon-button
            (click)="copyToClipboard(metadata.fileId)"
            matTooltip="Copy file ID"
            class="copy-button"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-list-item>

        <!-- File Path -->
        <mat-list-item>
          <span class="property-label">File Path</span>
          <span class="property-value code">{{ metadata.filePath }}</span>
        </mat-list-item>

        <!-- File Size -->
        <mat-list-item>
          <span class="property-label">File Size</span>
          <span class="property-value">{{ formatFileSize(metadata.fileSizeBytes) }}</span>
          <span class="property-value-detail">({{ metadata.fileSizeBytes | number }} bytes)</span>
        </mat-list-item>

        <!-- MIME Type -->
        <mat-list-item>
          <span class="property-label">MIME Type</span>
          <span class="property-value code">{{ metadata.mimeType }}</span>
        </mat-list-item>
      </mat-list>
    </div>

    <mat-divider></mat-divider>

    <!-- Document Classification Section -->
    <div class="properties-section">
      <h3 class="section-title">
        <mat-icon>category</mat-icon>
        Document Classification
      </h3>

      <mat-list>
        <!-- Document Type -->
        <mat-list-item>
          <span class="property-label">Document Type</span>
          <mat-chip class="document-type-chip">
            {{ formatDocumentType(metadata.documentType) }}
          </mat-chip>
        </mat-list-item>

        <!-- Page Count -->
        <mat-list-item>
          <span class="property-label">Total Pages</span>
          <span class="property-value">{{ metadata.pageCount || '—' }}</span>
        </mat-list-item>
      </mat-list>
    </div>

    <mat-divider></mat-divider>

    <!-- Processing Status Section -->
    <div class="properties-section">
      <h3 class="section-title">
        <mat-icon>timeline</mat-icon>
        Processing Status
      </h3>

      <mat-list>
        <!-- Processing Status -->
        <mat-list-item>
          <span class="property-label">Status</span>
          <mat-chip [class]="getStatusColorClass(metadata.processingStatus)">
            <mat-icon>{{ getStatusIcon(metadata.processingStatus) }}</mat-icon>
            {{ formatProcessingStatus(metadata.processingStatus) }}
          </mat-chip>
        </mat-list-item>

        <!-- Upload Date -->
        <mat-list-item>
          <span class="property-label">Upload Date</span>
          <span class="property-value">{{ metadata.uploadDate | date: 'medium' }}</span>
        </mat-list-item>

        <!-- Processed Date -->
        @if (metadata.processedDate) {
          <mat-list-item>
            <span class="property-label">Processed Date</span>
            <span class="property-value">{{ metadata.processedDate | date: 'medium' }}</span>
          </mat-list-item>
        }

        <!-- Extracted Pages -->
        @if (metadata.extractedPagesList && metadata.extractedPagesList.length > 0) {
          <mat-list-item>
            <span class="property-label">Extracted Pages</span>
            <div class="property-value">
              <mat-chip-set>
                @for (page of metadata.extractedPagesList.slice(0, 10); track page) {
                  <mat-chip>
                    {{ page }}
                  </mat-chip>
                }
                @if (metadata.extractedPagesList.length > 10) {
                  <mat-chip class="more-chip"> +{{ metadata.extractedPagesList.length - 10 }} more </mat-chip>
                }
              </mat-chip-set>
            </div>
          </mat-list-item>
        }
      </mat-list>
    </div>

    <mat-divider></mat-divider>

    <!-- Technical Details Section -->
    <div class="properties-section">
      <h3 class="section-title">
        <mat-icon>settings</mat-icon>
        Technical Details
      </h3>

      <mat-list>
        <!-- Checksum -->
        @if (metadata.checksumMd5) {
          <mat-list-item>
            <span class="property-label">MD5 Checksum</span>
            <span class="property-value code checksum">{{ metadata.checksumMd5 }}</span>
            <button
              mat-icon-button
              (click)="copyToClipboard(metadata.checksumMd5)"
              matTooltip="Copy checksum"
              class="copy-button"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          </mat-list-item>
        }

        <!-- Content Summary (if available) -->
        @if (metadata.contentSummary) {
          <mat-list-item>
            <span class="property-label">Content Summary</span>
            <span class="property-value summary">{{ metadata.contentSummary }}</span>
          </mat-list-item>
        }
      </mat-list>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="close()">Close</button>
  </div>
</div>
